import { render, staticRenderFns } from "./SpecialContent.vue?vue&type=template&id=92227c50&"
import script from "./SpecialContent.vue?vue&type=script&lang=js&"
export * from "./SpecialContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports